<template>
  <div v-if="isShow" class="overlay">
    <div class="inner">
      <ValidationObserver ref="observer">
        <div class="wrapper">
          <div
            v-for="sc, idx in specialConsiderations"
            :key="idx"
            class="content-wrapper"
          >
            <b-button
              pill
              variant="danger"
              @click="deleteSpecialConsideration(idx)"
              class="delete-button"
            >
              Delete
              <font-awesome-icon class="minus" icon="minus"/>
            </b-button>
            <div class="content">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <SelectSpecialConsiderationInput v-model="sc.specialConsideration" />
                <div class="error-text">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="content">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <p class="text">Comment</p>
                <textarea rows="10" class="comment" v-model="sc.comment"></textarea>
                <div class="error-text">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="button-container add">
          <b-button pill variant="secondary" @click="addSpecialConsideration">
            Add
            <font-awesome-icon class="plus" icon="plus"/>
          </b-button>
        </div>
      </ValidationObserver>
      <div class="button-container">
        <b-button pill variant="secondary" @click="close">
          Back
        </b-button>
        <b-button pill variant="primary" @click="save">
          Save
        </b-button>
      </div>
    </div>
    <Loading :isLoading="isLoading" />

  </div>
</template>

<script lang="ts">
import {
  Vue, Prop, Component, Watch,
} from 'vue-property-decorator'
import _ from 'lodash'
import SelectSpecialConsiderationInput from '@/components/parts/inputItem/SelectSpecialConsiderationInput.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { SpecialConsideration, CourseHistory } from '@/store/students/types'

import Loading from '@/components/parts/modal/Loading.vue'

@Component({
  components: {
    SelectSpecialConsiderationInput,
    ValidationProvider,
    ValidationObserver,
    Loading,
  },
})
export default class SpecialConsiderationModal extends Vue {
  private specialConsiderations: SpecialConsideration[] = []

  private courseHistoryId!: String

  private isLoading: boolean = false

  private isShow: boolean = false;

  open(selectedHistory: CourseHistory) {
    this.isShow = true
    this.specialConsiderations = _.cloneDeep(selectedHistory.specialConsiderations)
    this.courseHistoryId = selectedHistory.courseHistoryId
  }

  close() {
    this.isShow = false
  }

  private addSpecialConsideration() {
    this.specialConsiderations.push({
      specialConsideration: null,
      comment: '',
    })
  }

  private deleteSpecialConsideration(commentIndex: number) {
    this.specialConsiderations.splice(commentIndex, 1)
  }

  private save() {
    if (this.isLoading) {
      return
    }

    (this.$refs.observer as any).validate().then((result: any) => {
      if (!result) {
        return
      }
      this.isLoading = true

      this.$store.dispatch('updateSpecialConsideration', {
        studentId: this.$route.params.id,
        courseHistoryId: this.courseHistoryId,
        specialConsiderations: this.specialConsiderations,
      }).then(() => {
        this.$store.dispatch('getStudent', { studentId: this.$route.params.id })
      }).finally(() => {
        this.isLoading = false
        this.close()
      })
    })
  }
}
</script>

<style scoped>
.content-wrapper{
  min-height: auto;
}
.overlay{
  z-index:999;
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.inner{
  z-index:2;
  width: 60%;
  padding: 70px;
  background:#D0CECE;
  border-radius: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.content {
  margin-bottom:10px;
}

select {
  padding: 5px;
  border: 1px solid #AAAFB6;
  border-radius: 30px;
  width: 200px;
  height: 30px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.comment {
  width: 100%;
  border: 1px solid #AAAFB6;
  box-sizing: border-box;
  border-radius: 20px;
  padding:10px;
  margin-bottom:20px;
}

.text {
  margin-bottom: 15px;
  font-size: 17px;
  font-weight: bold;
}

.button-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.button-container.add {
  justify-content: flex-end;
}

.delete-button {
  position: absolute;
  right:20px;
  top:20px;
}

.content-wrapper {
  position: relative;
}

.wrapper {
  padding-right: 10px;
  margin-bottom:20px;
  max-height:500px;
  overflow-y:scroll;
}

.wrapper::-webkit-scrollbar{
  width: 15px;
}
.wrapper::-webkit-scrollbar-track{
  background: #fff;
  border: none;
  border-radius: 10px;
  box-shadow: inset 0 0 2px #777;
}
.wrapper::-webkit-scrollbar-thumb{
  background: #eeeeee;
  border-radius: 10px;
  box-shadow: none;
}

</style>
